import {
    IPresentationConfig,
    Presentation,
    PresentationState
} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {WGParsedGameData} from "../../../server/data/WGParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StateHandler} from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Linear, Timeline, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {WGGameConfig} from "../../../WGGameConfig";
import {WGBigWinCountUp} from "./WGBigWinCountUp";
import {CoinsFountain} from "./CoinsFountain";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SoundManager} from "../../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../../WGSoundConfig";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WGEngineManager} from "../../../engine/WGEngineManager";
import {WarriorGraveyardGameModuleConfig} from "../../../WarriorGraveyardGameModuleConfig";
import {WGSpriteSymbol} from "../../../engine/Symbol/WGSpriteSymbol";

export class BigWinStates extends StateHandler {
    public static readonly LEVEL_0: string = "LEVEL_0"; // prepare
    public static readonly LEVEL_1: string = "LEVEL_1"; //hold
    public static readonly LEVEL_2: string = "LEVEL_2";// charge
    public static readonly LEVEL_3: string = "LEVEL_3"; // fight
    public static readonly LEVEL_4: string = "LEVEL_4"; //glorioudDeath
}

export class BigWinPrsentation extends Presentation {
    private _bigWinState: BigWinStates = new BigWinStates();
    //graphics
    private _bigwinTextLabel: PIXI.Sprite;
    private _bigwinLevelCharacter: PIXI.Sprite[] = [];
    private _winLevel: number;
    private _finalLevel: number = 0
    private _gameData: WGParsedGameData;
    private _winRatios = WGGameConfig.instance.WIN_RATIOS.bigWin;
    private _winCountup: WGBigWinCountUp;
    private _coinsFountain: CoinsFountain;
    private _explosion: PIXI.spine.Spine;
    private characterTimeline: TimelineMax;
    private pumpUp_tl: TimelineMax;
    private duration = [0.25, 0.25, 0.25, 0.25, 0.25];
    private _fire: TimelineSprite;
    private _currentLevel: string = "";
    private _symWinStates: boolean[][] = [];
    public static _skippedOnLastLevel: boolean = false;

    constructor(config?: IPresentationConfig, customConfig?: any) {
        super(config, customConfig);
        this._winCountup = this.addChild(new WGBigWinCountUp());
        this._coinsFountain = new CoinsFountain();
    }

    public initialization(): void {
        this.characterTimeline = new TimelineMax();
        this._bigwinTextLabel = new PIXI.Sprite(GameResources.getTextures(BigWinStates.LEVEL_0 + "_label")[0]);
        this._bigwinTextLabel.anchor.set(0.5, 0.5);
        this._bigwinTextLabel.position.set(360, 140);
        for (let i = 0; i < 5; i++) {
            let sprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(`LEVEL_${i}` + "_character")[0]);
            sprite.anchor.set(0.5, 0.5);
            sprite.position.set(360, 500);
            this.addChildAt(sprite, 0);
            sprite.visible = false;
            this._bigwinLevelCharacter.push(sprite);
        }
        this.createBigWinFire();
        this._winCountup.position.set(360, 300);
        this._explosion = new PIXI.spine.Spine(GameResources.getSpineAsset("bigwinExplosion"));
        this._explosion.position.set(360, 150);
        this._explosion.visible = false;
        this.addChildAt(this._explosion, 0);
    }

    public onResize(resizeData?: IResizeData): void {
        super.onResize && super.onResize(resizeData);
        this.setFireProps();
    }

    public checkForActivation(data: WGParsedGameData): boolean {
        BigWinPrsentation._skippedOnLastLevel = false;
        return (data.isBigWin && data.singleWin > 0);
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this._gameData = data;
        this._bigWinState.set(BigWinStates.LEVEL_0);
        this.getBigWinLevelLimit(data.currentWinRatio);
        this._finalLevel = this._winLevel;
        this._symWinStates = data.symbolWinStates;
    }

    public getPresentation(): void {
        if (this._winLevel > -1) { // added this check to play bigwin levels according to winning amount
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
            switch (this._bigWinState.state) {
                case BigWinStates.LEVEL_0:
                case BigWinStates.LEVEL_1:
                case BigWinStates.LEVEL_2:
                case BigWinStates.LEVEL_3:
                case BigWinStates.LEVEL_4:
                    const level: number = (Number(this._bigWinState.state.split("_")[1]))
                    SoundManager.playSoundEffect(WGSoundConfig.instance.BIG_WIN_LEVEL_SOUNDS[level]);
                    this.playLabelAnimation(this._bigWinState.state + "_label");
                    this.playCharacterAnimation(this._bigWinState.state + "_character");
                    this.playCountup(this._bigWinState.state);
                    this.playBigWinFire(this._bigWinState.state);
                    break;
            }
        } else {
            let positionOffset: number = 0;
            if (!BigWinPrsentation._skippedOnLastLevel) {
                if (this._currentLevel === "0") {
                    positionOffset = 1;
                } else if (this._currentLevel === "1") {
                    positionOffset = 1.5;
                } else if (this._currentLevel === "2") {
                    positionOffset = 2;
                } else if (this._currentLevel === "3") {
                    positionOffset = 3;
                } else if (this._currentLevel === "4") {
                    positionOffset = 5;
                }
            } else {
                positionOffset = 1;
            }


            this.pTimeline.add(() => {
                SoundManager.playSoundEffect(WGSoundConfig.instance.BIG_WIN_ENDS);
                SoundManager.fadeAmbienceLoop(1, 2000);

                WGEngineManager.RAll((reel: number) => {
                    for (let i: number = 0; i < 3; i++) {
                        if (this._symWinStates[reel][i]) {
                            const symbol: WGSpriteSymbol = WGEngineManager.getReel(reel).getSymbol(i)!;
                            if (symbol) {
                                WarriorGraveyardGameModuleConfig.betlineWinBox.handleSymbolState(symbol, reel, i, reel, true);
                            }
                        }
                    }
                });
            });
            this.pTimeline.add(() => this.PresentationState.set(PresentationState.INACTIVE), positionOffset);
        }
    }

    private createBigWinFire(): void {
        this._fire = new TimelineSprite(GameResources.getTextures("bigWinFire"));
        this._fire.hide();
        this._fire.anchor.set(0.5);
        this._fire.blendMode = PIXI.BLEND_MODES.ADD;
        this._fire.position.set(360, 0);
        this._fire.scale.x = 2;
        this.addChild(this._fire);
    }

    private stopAllBigWinLevelSounds(): void {
        for (let i = 0; i <= 4; i++) {
            SoundManager.stopSoundEffect(WGSoundConfig.instance.BIG_WIN_LEVEL_SOUNDS[i]);
        }
    }

    /**
     * function to play big win level animation
     * @param name : to show animation according to level
     */
    private playLabelAnimation(name: string): void {
        this._bigwinTextLabel.texture = GameResources.getTextures(name)[0];
        this._bigwinTextLabel.alpha = 1;
        this._bigwinTextLabel.visible = true;
        this._bigwinTextLabel.scale.set(0);
        this.addChild(this._bigwinTextLabel);
        const level: number = (Number(name.split("_")[1]));
        this._coinsFountain.startFountain(level);
        this.pTimeline.add(() => {
            TweenLite.fromTo(this._bigwinTextLabel.scale, 0.1, {x: 0, y: 0}, {
                x: 0.8, y: 0.8, ease: Linear.easeNone
            });
            this._explosion.updateTransform();
            this._explosion.visible = true;
            new SpineTween(this._explosion, 0, "bw_explosion");
            this.startPumpUp(level);
        }, 0);
    }

    private startPumpUp(level: number): void {
        const duration = this.duration[level];
        const value = 0.05;
        const initScale = 0.8;
        const finalScale = initScale + value;
        this.pumpUp_tl = Helper.timeLineKiller(this.pumpUp_tl!, new TimelineMax({repeat: -1, yoyo: true}));
        this.pumpUp_tl.fromTo(this._bigwinTextLabel.scale, duration, {
            x: initScale,
            y: initScale
        }, {
            x: finalScale,
            y: finalScale,
            ease: Linear.easeNone
        });
    }

    /**
     * function to show/play character animation
     * @param name
     */
    private playCharacterAnimation(name: string): void {
        const level: number = (Number(name.split("_")[1]));
        const toScale: number = ((level > 3) ? (1.1 * 0.6) : (0.75 * 0.7));
        this.characterTimeline = Helper.timeLineKiller(this.characterTimeline, new TimelineMax());
        switch (level) {
            case 0:
                this._bigwinLevelCharacter[level].scale.set(toScale);
                this._bigwinLevelCharacter[level].alpha = 0;
                this._bigwinLevelCharacter[level].visible = true;
                this.characterTimeline.to(this._bigwinLevelCharacter[level], 0.5, {alpha: 1});
                this.characterTimeline.to(this._bigwinLevelCharacter[level].scale, this._winRatios[level].duration * 2, {
                    x: this._bigwinLevelCharacter[level].scale.x * 2.5,
                    y: this._bigwinLevelCharacter[level].scale.y * 2.5
                });
                break
            case 1:
            case 2:
            case 3:
            case 4:
                this._bigwinLevelCharacter[level].scale.set(toScale);
                this._bigwinLevelCharacter[level].alpha = 0;
                this._bigwinLevelCharacter[level].visible = true;
                this.characterTimeline.to(this._bigwinLevelCharacter[level], 0.2, {alpha: 1}, 0);
                this.characterTimeline.to(this._bigwinLevelCharacter[level - 1], 0.2, {alpha: 0}, 0);
                this.characterTimeline.to(this._bigwinLevelCharacter[level].scale, this._winRatios[level].duration * 2, {
                    x: this._bigwinLevelCharacter[level].scale.x * 2.5,
                    y: this._bigwinLevelCharacter[level].scale.y * 2.5
                }, 0);
                break
        }
    }

    private playCountup(level: string): void {
        const levelnum: number = (Number(level.split("_")[1]));
        this.pTimeline.add(this.playBigWinCountUp(levelnum));
        this.pTimeline.add(() => {
            if (this.pumpUp_tl) {
                this.pumpUp_tl.clear(true);
                this.pumpUp_tl.kill();
            }
        }, (this.pTimeline.totalDuration() - 0.1));
        this.pTimeline.add(() => this._bigWinState.set(("LEVEL_" + (Number(level.split("_")[1]) + 1).toString())), 0);

        if (levelnum !== this._finalLevel) {
            this.pTimeline.to(this._bigwinTextLabel.scale, 0.1, {
                x: 0,
                y: 0,
                ease: Linear.easeNone
            }, (this.pTimeline.totalDuration() - 0.1));
        }
    }

    /**
     * function to play bigWin Count
     * @param level
     */
    private playBigWinCountUp(level: number): Timeline | null {
        this._winCountup.visible = true;
        const duration: number = WGGameConfig.instance.WIN_RATIOS.bigWin[level].duration;
        const fromValue: number = level === 0 ? 0 : this._gameData!.playedBetValue * WGGameConfig.instance.WIN_RATIOS.bigWin[level].ratio;
        const toValue: number = this._winLevel === 0 ? this._gameData!.singleWin : this._gameData!.playedBetValue * WGGameConfig.instance.WIN_RATIOS.bigWin[level + 1].ratio;
        const timeline: TimelineLite = new TimelineLite();
        this._winLevel--;
        timeline.add([
            this._winCountup.getCountUpAnimation(fromValue, toValue, duration)
        ]);
        return timeline;
    }

    private playBigWinFire(levelName: string): void {
        this.pTimeline.add(() => {
            this._currentLevel = levelName.split("_")[1];
            this.setFireProps();
            this._fire.show();
            this._fire.playLoop();
        }, 0);
    }

    private setFireProps(): void {
        if (this._currentLevel === "") {
            return;
        }

        let yOffset: number = 0,
            heightCalculator: number = 0;
        if (this._currentLevel === "0") {
            yOffset = 40;
            heightCalculator = 0.2;
        } else if (this._currentLevel === "1") {
            yOffset = 80;
            heightCalculator = 0.3;
        } else if (this._currentLevel === "2") {
            yOffset = 110;
            heightCalculator = 0.5;
        } else if (this._currentLevel === "3") {
            yOffset = 140;
            heightCalculator = 0.65;
        } else if (this._currentLevel === "4") {
            yOffset = 160;
            heightCalculator = 0.85;
        }
        this._fire.y = NolimitApplication.screenBounds.bottom - yOffset;
        this._fire.height = (NolimitApplication.screenBounds.height * heightCalculator);
    }

    /**
     * function to hide bigwin text
     * show win field amount
     */
    public stopPresentation(): void {
        this._winCountup.getBigWinEndingAnimation(BigWinPrsentation._skippedOnLastLevel);
        this._coinsFountain.stopFountain();
        let tl: TimelineMax = new TimelineMax({
            onComplete: () => {
                this._bigwinLevelCharacter.forEach(value => value.visible = false);
                Helper.timeLineKiller(this.characterTimeline);
                this._fire.stopLoop();
                this._fire.hide()
                this._fire.alpha = 1;
            }
        });

        this._explosion.visible = false;
        this._currentLevel = "";
        const duration: number = BigWinPrsentation._skippedOnLastLevel ? 1 : 0.2;
        tl.fromTo(this._bigwinTextLabel, duration, {alpha: 1}, {alpha: 0}, 0); // stay a while with count up.
        tl.fromTo(this._bigwinLevelCharacter[this._finalLevel], duration, {alpha: 1}, {alpha: 0}, 0); // stay a while with count up.
        tl.fromTo(this._fire, duration, {alpha: 1}, {alpha: 0}, 0); // stay a while with count up.

        SlotGame.winFieldController.showWinField();
    }

    /**
     * skip presentation will be called on each level skip
     */
    public skipPresentation(): void {
        BigWinPrsentation._skippedOnLastLevel = (this._currentLevel === (this._finalLevel + ""));
        this.stopAllBigWinLevelSounds();
        this.pTimeline!.totalProgress(1);
    }

    /**
     * function to calculate bigwin level based on current win ratio.
     * @param currentWinRatio
     */
    private getBigWinLevelLimit(currentWinRatio: number): void {
        for (let i: number = this._winRatios.length - 1; i >= 0; i--) {
            if (currentWinRatio >= this._winRatios[i].ratio) {
                this._winLevel = i;
                return;
            }
        }
    }
}